import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { getAnonId } from "@/lib/anonId";

export default function LikeButton({ newsId }) {
    const [count, setCount] = useState(0);
    const [liked, setLiked] = useState(false);
    const [busy, setBusy] = useState(false);
    const anonId = getAnonId();

    useEffect(() => {
        api.get(`/news/${newsId}/like`, { params: { anonymous_id: anonId } })
            .then((r) => { setCount(r.data.likes_count); setLiked(r.data.liked); })
            .catch(() => {});
    }, [newsId, anonId]);

    const toggle = async () => {
        if (busy) return;
        setBusy(true);
        try {
            const r = liked
                ? await api.delete(`/news/${newsId}/like`, { params: { anonymous_id: anonId } })
                : await api.post(`/news/${newsId}/like`, { anonymous_id: anonId });
            setCount(r.data.likes_count);
            setLiked(r.data.liked);
        } catch { /* ignore */ } finally { setBusy(false); }
    };

    return (
        <button
            type="button"
            onClick={toggle}
            disabled={busy}
            data-testid={`like-button-${newsId}`}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border transition-all disabled:opacity-60 ${
                liked
                    ? "bg-[#D4A537]/15 border-[#D4A537] text-[#B88A26]"
                    : "bg-white border-gray-200 text-[#092E22] hover:border-[#D4A537]/60 hover:bg-[#D4A537]/5"
            }`}
            aria-pressed={liked}
        >
            <Heart size={16} fill={liked ? "#D4A537" : "none"} className="transition-transform group-active:scale-90" />
            <span className="text-sm font-medium">{liked ? "Polubione" : "Polub"}</span>
            <span className="text-sm font-semibold tabular-nums">{count}</span>
        </button>
    );
}
